import { render, staticRenderFns } from "./LotDiscardG.vue?vue&type=template&id=6ca514c4"
import script from "./LotDiscardG.vue?vue&type=script&lang=js"
export * from "./LotDiscardG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports